import { Injectable } from '@angular/core';
import { HttpMethodsService } from '../_helpers/http-methods.service';
import { map } from 'rxjs/internal/operators/map';
import { StoresConstant } from '../stores_api/constants/stores.constant';
import { RetailStoreConstants } from '../../../routing/services/retail_api/constants/retailHq.constants';
import { GlobalConstants } from '../../../../common/constants/global.constant';
import { ActiveUserConstants } from '../activeusers_api/constatnts/activeusers.constant';

@Injectable({
  providedIn: 'root'
})
export class StoresService {

  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  userRole = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  retailerId = sessionStorage.getItem(GlobalConstants.RETAILER_ID);
  retailerName = sessionStorage.getItem(GlobalConstants.RETAILER_NAME);
  preferredLanguageName = localStorage.getItem('preferredLanguage');
  // TODO add logged in user email id
  INVITE_URL = StoresConstant.USERMGMT + StoresConstant.USERMANAGMENT +
    StoresConstant.SLASH_USERS + StoresConstant.SLASH + this.userId + StoresConstant.SLASH_USERS + StoresConstant.INVITE;
  COMMON_URL = StoresConstant.SLASH_RETAILSTORE + StoresConstant.SLASH_STORE + StoresConstant.SLASH_USERS + StoresConstant.SLASH;
  RETAILER_COMMON_URL = this.COMMON_URL + this.userId + StoresConstant.SLASH_RETAILER +
    StoresConstant.SLASH + this.retailerId;
  STORES_URL = this.COMMON_URL + this.userId + StoresConstant.STORES;
  REGIONAL_COMMON_URL = this.COMMON_URL + this.userId + StoresConstant.SLASH_RETAILER;
  STORES_URL_RETAIL = this.RETAILER_COMMON_URL + StoresConstant.STORES;
  SEARCH_URL = this.COMMON_URL + this.userId + StoresConstant.SLASH_STORE_SEARCH;
  RETAIL_SEARCH_URL = this.COMMON_URL + this.userId + StoresConstant.SLASH_RETAILER +
    StoresConstant.SLASH + this.retailerId + StoresConstant.SLASH_STORE_SEARCH;
  constructor(private httpMethod: HttpMethodsService) {
    if (this.preferredLanguageName === 'zh-Hans') {
      this.preferredLanguageName = 'zh-cn';
    } else if (this.preferredLanguageName === 'zh-Hant') {
      this.preferredLanguageName = 'zh-tw';
    }
   }

  getAllStoresbyUserID(sortby: string, sorttype: string, pageNumber: number, filterString?: string, retailerUserId?: string) {
    let url = (this.userRole === GlobalConstants.RETAIL_HQ_USER) ? this.STORES_URL_RETAIL +
      StoresConstant.SORTBY + sortby + StoresConstant.SORT_TYPE + sorttype  
      : (this.userRole === ActiveUserConstants.REGIONAL_USER_ROLE) ? this.REGIONAL_COMMON_URL + StoresConstant.SLASH + retailerUserId + StoresConstant.STORES +
        StoresConstant.SORTBY + sortby + StoresConstant.SORT_TYPE + sorttype : this.STORES_URL + StoresConstant.SORTBY + sortby + StoresConstant.SORT_TYPE + sorttype ;
    if(pageNumber){
      url+= StoresConstant.PAGE_NUMBER + StoresConstant.EQUALS + pageNumber;
    }

    if (filterString) {
      url = `${url}${filterString}`;
    }

    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getAllStores(sortby: string, sorttype: string, filters?: string, retailerID?: string) {
    let url = (this.userRole === GlobalConstants.RETAIL_HQ_USER) ? this.STORES_URL_RETAIL +
      StoresConstant.SORTBY + sortby + StoresConstant.SORT_TYPE + sorttype
      : this.STORES_URL + StoresConstant.SORTBY + sortby + StoresConstant.SORT_TYPE + sorttype;

    if (this.userRole === GlobalConstants.REGIONALHQ) {
      url = this.COMMON_URL + this.userId + StoresConstant.SLASH_RETAILER +
        StoresConstant.SLASH + retailerID + StoresConstant.STORES + StoresConstant.SORTBY + sortby + StoresConstant.SORT_TYPE + sorttype;
    }


    if (filters) {
      url = url + filters;
    }
    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getAllStoresInfoById(userID: string, retailerId: string, storeId: string) {
    const url = this.COMMON_URL + userID + StoresConstant.SLASH_RETAILER + StoresConstant.SLASH + retailerId
      + StoresConstant.STORES + StoresConstant.SLASH + storeId;

    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getStoresbySearch(searchTag: string, searchData: string) {
    const url = (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.REGIONALHQ) ?
      this.RETAILER_COMMON_URL + StoresConstant.SLASH_STORE_SEARCH + searchTag + StoresConstant.EQUALS + searchData :
      this.COMMON_URL + this.userId + StoresConstant.SLASH_STORE_SEARCH + searchTag + StoresConstant.EQUALS + searchData;

    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getStoresbyFilter(filterString: string) {
    const url = (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.REGIONALHQ) ? this.RETAILER_COMMON_URL + StoresConstant.SLASH_STORE_SEARCH +
      filterString : this.COMMON_URL + this.userId + StoresConstant.SLASH_STORE_SEARCH +
    filterString;

    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        (res))
      );
  }

  sort(globalsortValue: string) {

    return this.httpMethod.get(this.COMMON_URL + this.userId + StoresConstant.SLASH_STORE_SEARCH +
      globalsortValue)
      .pipe(map((res: any) =>
        res));
  }

  createNewStore(storesContent: {
    storeName: any; retailerName: any; storeNumber: any; customStoreID: any; country: any;
    stateRegionProvince: any; address: any; postalCode: any; createdByName: any; createdByUserID: any
  }, retailerID: string) {
    storesContent.createdByUserID = this.userId;

    return this.httpMethod.post(this.COMMON_URL + this.userId + StoresConstant.SLASH_RETAILER + StoresConstant.SLASH +
      retailerID + StoresConstant.STORES, storesContent)
      .pipe(map((res: any) =>
        res));
  }

  editStore(editData: any) {
    return this.httpMethod.put(this.COMMON_URL + this.userId + StoresConstant.SLASH_RETAILER + StoresConstant.SLASH + editData.retailerId +
      StoresConstant.STORES + StoresConstant.SLASH + editData.storeId, editData)
      .pipe(map((res: any) =>
        res));
  }

  createBatchAdd(configurationsJson: object) {
    const url = this.STORES_URL + StoresConstant.UPLOADSTORES + StoresConstant.SELECTED_LANGUAGE_ADMIN + this.preferredLanguageName;

    return this.httpMethod.postBatch(url, configurationsJson)
      .pipe(map((res: any) =>
        res));
  }

  createBatchAddByRetailHq(configurationsJson: object, retID, retName) {
    const url = this.COMMON_URL + this.userId + StoresConstant.SLASH_RETAILER +
    StoresConstant.SLASH + retID + StoresConstant.STORES + StoresConstant.UPLOADSTORES + StoresConstant.RETAILER_NAME_CHECK + retName + StoresConstant.SELECTED_LANGUAGE + this.preferredLanguageName;
    return this.httpMethod.postBatch(url, configurationsJson)
      .pipe(map((res: any) =>
        res));
  }

  inviteStoreUser(userRole: object) {
    return this.httpMethod.post(this.INVITE_URL, userRole)
      .pipe(map((res: any) =>
        res));
  }

  postAllStoresForCsv(userID: string, params) {
    return this.httpMethod.postcsv(this.COMMON_URL + userID + StoresConstant.STORES
      + StoresConstant.SLASH + StoresConstant.DOWNLOAD, params)
      .pipe(map((res: any) =>
        res));
  }

  postAllStoresForCsvRetailHq(userID: string, params) {
    return this.httpMethod.postcsv(this.COMMON_URL + userID + StoresConstant.SLASH_RETAILER + StoresConstant.SLASH
      + sessionStorage.getItem(GlobalConstants.RETAILER_ID) + StoresConstant.STORES + StoresConstant.SLASH + StoresConstant.DOWNLOAD, params)
      .pipe(map((res: any) =>
        res));
  }

  postdownloadcsvStoresbyFilter(filterString: string, params) {
    return this.httpMethod.postfiltercsv(this.COMMON_URL + this.userId + StoresConstant.STORES
      + StoresConstant.SLASH + StoresConstant.DOWNLOAD + StoresConstant.SEARCH_QUERY +
      filterString, JSON.stringify(params))
      .pipe(map((res: any) =>
        (res))
      );
  }

  postdownloadcsvStoresbyFilterRetailHq(filterString: string, params) {
    return this.httpMethod.postfiltercsv(this.COMMON_URL + this.userId + StoresConstant.SLASH_RETAILER
      + StoresConstant.SLASH + sessionStorage.getItem(GlobalConstants.RETAILER_ID) + StoresConstant.STORES
      + StoresConstant.SLASH + StoresConstant.DOWNLOAD + StoresConstant.SEARCH_QUERY +
      filterString, JSON.stringify(params))
      .pipe(map((res: any) =>
        (res))
      );
  }

  getStoreByUserIDRetailer(retailerName) {
    let url = this.COMMON_URL + this.userId + StoresConstant.STORES + ActiveUserConstants.SEARCH_QUERY + ActiveUserConstants.RETAILHQ_VALUE_FILTER + ActiveUserConstants.EQUALS + retailerName;
    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        (res))
      );
  }
  // For pop-up content in delete single or multiple stores
  deleteStoresByStoreIds(stores) {
    const url = `${RetailStoreConstants.SLASH_RETAILER_STORE}${RetailStoreConstants.DELETE_STORES}`
    return this.httpMethod.post(url, stores)
      .pipe(map((res: any) =>
        (res))
      );
  }

  // Confirmation to delete single or multiple stores.
  confirmDeleteStoresByIds(confirmStores) {
    const url = `${RetailStoreConstants.SLASH_RETAILER_STORE}${RetailStoreConstants.CONFIRM_DELETE_STORES}`
    return this.httpMethod.deleteUser(url, confirmStores)
      .pipe(map((res: any) =>
        (res))
      );
  }
}
